import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvironmentData } from '../../environments/environment-data';

@Injectable({
  providedIn: 'root',
})
export class OmniIdentityService {
  constructor(private http: HttpClient) {}

  public async getOrganization(
    clientToken: string,
    lookup: string,
  ): Promise<any> {
    // const url = this.OMNI_API_URL + '/organizations';
    const url = EnvironmentData.getHubUrl() + '/organizations';
    const headers = new HttpHeaders({
      Authorization: clientToken,
    });
    return this.http
      .get<any>(url, {
        headers,
        params: {
          filter: 'lookup eq ' + lookup,
        },
      })
      .toPromise();
  }
}
